var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-features-title'),_c('v-features-list'),_c('v-features-messages'),_c('v-features-action-buttons')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }